import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { up } from 'styled-breakpoints'

import IconLink from './icon-link'
import { socialLinks } from './links'

import { useAuth } from '../../../data/hooks/auth'

type SocialProps = {
    className?: string
    inverted?: boolean
}

const Social: React.FunctionComponent<SocialProps> = ({ className, inverted }) => {
    const { user } = useAuth()

    return (
        <Container className={className}>
            { !user && <LoginButton to={'/auth/login'}>Login</LoginButton> }
            {socialLinks.map((l, i) => <IconLink key={i} {...l} inverted={inverted || false} />)}
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    width: fit-content;
    align-items: center;
    
    grid-column-gap: 12px;
`

const LoginButton = styled(Link)`
    display: grid;
    padding: 5px 10px;
    
    background: ${p => p.theme.colors.accent};
    border-radius: 10px;

    font-size: 16px;
    line-height: 28px;

    &, &:visited, &:active {
        text-decoration: none;
        color: ${p => p.theme.colors.bg};
    }

    ${up('tablet')} {
        padding: 10px 20px;
    }
`


export default Social